import type { IconData } from '@stacksjs/iconify-core'

export const starCircle: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 3a21 21 0 1 0 0 42a21 21 0 1 0 0-42\"/><path d=\"M22.224 12.423c.747-1.439 2.805-1.439 3.551 0l2.81 5.418l5.96 1.174c1.522.3 2.138 2.145 1.1 3.3l-4.225 4.698l.776 6.288c.195 1.584-1.45 2.747-2.878 2.035L24 32.68l-5.318 2.655c-1.427.712-3.073-.451-2.878-2.035l.776-6.288l-4.225-4.699c-1.038-1.154-.422-3 1.1-3.3l5.96-1.173l2.81-5.418Z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default starCircle
